import { MoreVertical } from 'lucide-react';
import { memo } from 'react';
import { Bar, BarChart, ResponsiveContainer } from 'recharts';

const clicksData = [
    { month: 'Jan', value: 20 },
    { month: 'Feb', value: 35 },
    { month: 'Mar', value: 45 },
    { month: 'Apr', value: 40 },
    { month: 'May', value: 55 },
    { month: 'Jun', value: 50 },
    { month: 'Jul', value: 60 },
    { month: 'Aug', value: 65 },
    { month: 'Sep', value: 70 }
];

function TotalClicks() {
    return (<div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50">
        <div className="flex items-center justify-between mb-2">
            <div>
                <h3 className="text-white text-lg font-semibold">82.7K</h3>
                <p className="text-slate-400 text-sm">Total Clicks</p>
            </div>
            <MoreVertical className="text-slate-400" size={20} />
        </div>
        <ResponsiveContainer width="100%" height={120}>
            <BarChart data={clicksData}>
                <Bar dataKey="value" fill="#ec4899" radius={[4, 4, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
        <p className="text-emerald-400 text-sm mt-2">12.5% from last month</p>
    </div>);
}

export default memo(TotalClicks);